/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React from 'react'
import PropTypes from 'prop-types'

import EmailComposer from 'components/App/DesktopView/shared/Composer/Email'
import debug from 'util/debug'
import { curry } from 'util/functions'
import editor from 'shared/editor/utils'

import Editor from './Editor'
import Header from './Header'
import styles from '../shared/styles.css'

class ReplyingState extends React.Component {
  static propTypes = {
    doOpenTicketPage: PropTypes.func.isRequired,
    doRealtimeAgentStartTicketTypingNotification: PropTypes.func.isRequired,
    draft: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    draftType: PropTypes.string,
    isAgentColliding: PropTypes.bool.isRequired,
    isDraftSendable: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired, // is ticket open
    showingCanned: PropTypes.bool.isRequired, // canned reply menu open
    ticketId: PropTypes.string.isRequired,
    onEditorBlur: PropTypes.func,
    onEditorFocus: PropTypes.func,
    updateAndSendDraft: PropTypes.func.isRequired,
    updateDraft: PropTypes.func.isRequired,
    updateDraftDelayed: PropTypes.func.isRequired,
    isForwarding: PropTypes.bool.isRequired,
    viaKeyboard: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    onEditorBlur: undefined,
    onEditorFocus: undefined,
  }

  componentDidMount() {
    // A little Janky (TM) but our draft selector does the heavy lifting for
    // fetching saved drafts (in LS or from server) and building a draft object.
    // Rather than try to rewrite this into reducers, we just load the saved
    // draft every time you hit this page. It assumes you have already set up
    // the draftType and default recipients in the _PAGE reducer
    const { doInitializeDraft, ticketId, draft, usesDraftsV2 } = this.props
    if (usesDraftsV2) return
    doInitializeDraft(ticketId, draft)
  }

  componentDidUpdate(prevProps) {
    // WARNING!!!
    // For a reason I cannot explain there are cases when the props.ticketId
    // doesnt match props.draft.ticketId. In order to prevent us from initializing
    // a draft on ticket 1 using data from ticket 2, we'll rather just look at
    // the props.draft.ticketId
    if (this.props.draft.ticketId !== prevProps.draft.ticketId) {
      const { doInitializeDraft, ticketId, draft, usesDraftsV2 } = this.props
      if (usesDraftsV2) return
      doInitializeDraft(ticketId, draft)
    }
  }

  focusEditor = () => {
    setTimeout(() => editor.focus(), 50)
  }

  startTyping = () => {
    const {
      ticketId,
      doRealtimeAgentStartTicketTypingNotification,
    } = this.props
    doRealtimeAgentStartTicketTypingNotification(ticketId)
  }

  handleDeleteDraft = ticketId => {
    this.props.doOpenTicketPage(ticketId)
  }

  // Runs given function if no collision. If collision, pops up confirmation
  // window first.
  checkBeforeSend = () => {
    const { isAgentColliding } = this.props
    if (isAgentColliding) {
      const msg = `Another ${app.t(
        'agent'
      )} is replying. Are you sure you want to send?`
      if (!window.confirm(msg)) return false // eslint-disable-line no-alert
    }
    return true
  }

  emitResizeEvent = () => {
    debug('editorResized')
    window.dispatchEvent(new CustomEvent('editorResized'))
  }

  focusWhenInitialized() {
    const { showingCanned, viaKeyboard } = this.props
    if (viaKeyboard && !showingCanned) return true
    return false
  }

  render() {
    const {
      draft,
      draftType,
      isDraftSendable,
      isOpen,
      onEditorBlur,
      onEditorFocus,
      ticketId,
      updateDraft,
      updateDraftDelayed,
      updateAndSendDraft,
    } = this.props

    const header = (
      <Header
        draft={draft}
        draftType={draftType}
        onMailboxClick={curry(updateDraft)(ticketId)('mailboxId')}
        onSubjectChange={curry(updateDraftDelayed)(ticketId)('title')}
        onSubjectEnter={this.focusEditor}
        ticketId={ticketId}
      />
    )

    return (
      <EmailComposer
        className={styles.ReplyForm}
        content={draft.body}
        draft={draft}
        editor={Editor}
        focusWhenInitialized={this.focusWhenInitialized()}
        header={header}
        isDraftSendable={isDraftSendable}
        isOpen={isOpen}
        onBeforeSend={this.checkBeforeSend}
        onBodyChange={this.startTyping}
        onEditorBlur={onEditorBlur}
        onEditorFocus={onEditorFocus}
        onEditorResize={this.emitResizeEvent}
        onDeleteDraft={this.handleDeleteDraft}
        showAttachmentIcon
        showToolbarIcon
        ticketId={ticketId}
        updateAndSendDraft={updateAndSendDraft}
      />
    )
  }
}

export default ReplyingState
